if (document.querySelector('.simple-articles')) {
    const articles = document.querySelectorAll('.simple-articles article');
    const articleImg = document.querySelector('.simple-article-img');

    articleImg.src = articles[0].getAttribute('data-img');

    articles.forEach(article => {
        const imgSrc = article.getAttribute('data-img');

        article.addEventListener('mouseenter', () => {
            articleImg.src = imgSrc;
        });
    });
}
